import { Navigate, useLocation } from "react-router-dom";
import { getModulePath, LEAGUE_MODULE_NAMES } from "@leagueplatform/core";

export const LEGACY_HEALTH_PROFILE_PATH = "/member/health-profile";

export const HealthProfileRedirect = () => {
  const { pathname, search, hash } = useLocation();
  const healthProfilePath = getModulePath(LEAGUE_MODULE_NAMES.healthProfile);
  const suffix = pathname.slice(LEGACY_HEALTH_PROFILE_PATH.length);

  return (
    <Navigate to={`${healthProfilePath}${suffix}${search}${hash}`} replace />
  );
};
